"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ukTaxBracket = void 0;
exports.ukTaxBracket = [
    [0, 12570, 0],
    [12570, 50270, 0.2],
    [50270, 125140, 0.4],
    [125140, 999999999, 0.45],
];
